var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExitIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 28 28",
    style: {
      enableBackground: "new 0 0 28 28"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.4;fill:#666666;}\n\t.st1{fill:#666666;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "c142_x"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14,0C6.3,0,0,6.3,0,14c0,7.7,6.3,14,14,14c7.7,0,14-6.3,14-14C28,6.3,21.7,0,14,0z M20,17.8L17.8,20 c0,0-3.5-3.8-3.8-3.8S10.2,20,10.2,20L8,17.8c0,0,3.8-3.5,3.8-3.8c0-0.3-3.8-3.8-3.8-3.8L10.2,8c0,0,3.5,3.8,3.8,3.8 c0.2,0,3.8-3.8,3.8-3.8l2.2,2.2c0,0-3.8,3.5-3.8,3.8C16.2,14.2,20,17.8,20,17.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20,17.8L17.8,20c0,0-3.5-3.8-3.8-3.8S10.2,20,10.2,20L8,17.8c0,0,3.8-3.5,3.8-3.8c0-0.3-3.8-3.8-3.8-3.8 L10.2,8c0,0,3.5,3.8,3.8,3.8c0.2,0,3.8-3.8,3.8-3.8l2.2,2.2c0,0-3.8,3.5-3.8,3.8C16.2,14.2,20,17.8,20,17.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Capa_1_104_"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitIcon);
export default __webpack_public_path__ + "static/media/exit-icon.880376648716acac6886f28f09dbc702.svg";
export { ForwardRef as ReactComponent };